import React from "react";
import { ReactComponent as Success } from "./success.svg";
import { useNavigate } from "react-router-dom";

function ReportSuccess({ authenticated, prevStep }) {
  const navigate = useNavigate();

  return (
    <section className="max-w-[1280px] px-4 md:px-10 mx-auto">
      <div className="bg-[#F3F5F9] px-4 flex flex-col justify-center items-center md:mt-4 lg:mt-4 border h-screen lg:h-[500px] rounded-3xl lg:pb-16 lg:w-[400px] lg:mx-auto">
        <Success className="mx-auto" />
        <div className="flex flex-col space-y-5">
          <h3 className="text-pw-blue font-bold text-[24px] text-center leading-[28.3px]">
            Leakage Report submitted successfully
          </h3>
          <p className="text-black text-sm leading-6 text-center">
            Our team will work on it as soon as possible.
            <br /> Thank you for your cooperation.
          </p>
        </div>
        <button
          onClick={() => {
            if (authenticated && prevStep) {
              prevStep();
              return;
            }
            navigate("/");
          }}
          className="py-[17px] mt-8 px-[60px] bg-pw-blue text-white rounded-3xl hover:bg-cyan-500"
        >
          Back
        </button>
      </div>
    </section>
  );
}

export default ReportSuccess;
